import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import useButtonLoader from "../../hooks/useButtonLoader";
import { Url } from "../../config/config";

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["link", "image"],
    ["clean"],
  ],
};

export default function AddBlog() {
  const navigate = useNavigate();
  const [submitButtonElement, setSubmitLoading] = useButtonLoader(
    "Submit",
    "Please wait..."
  );

  const [inputField, setInputField] = useState({
    title: "",
    author: "",
    isFeatured: false,
    metaTitle: "",
    metaDescription: "",
  });

  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const [errorField, setErrorField] = useState({});

  const handelInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setInputField({
      ...inputField,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handelImageOnchange = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
      setImagePreview(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;

    if (!inputField.title) {
      errors["title"] = "Title is required";
      formIsValid = false;
    }
    if (!inputField.author) {
      errors["author"] = "Author is required";
      formIsValid = false;
    }
    if (!description || description === "<p><br></p>") {
      errors["description"] = "Description is required";
      formIsValid = false;
    }
    if (!image) {
      errors["image"] = "Image is required";
      formIsValid = false;
    }

    setErrorField(errors);
    if (!formIsValid) setSubmitLoading(false);
    return formIsValid;
  };

  const handelSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitLoading(true);
      if (handleValidation()) {
        const formData = new FormData();
        formData.append("title", inputField.title);
        formData.append("author", inputField.author);
        formData.append("description", description);
        formData.append("isFeatured", inputField.isFeatured);
        formData.append("metaTitle", inputField.metaTitle);
        formData.append("metaDescription", inputField.metaDescription);
        formData.append("image", image);

        const res = await axios({
          url: `${Url}/blog/add`,
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
          data: formData,
        });

        setSubmitLoading(false);
        if (res.data.status === 200) {
          toast.success(res.data.message);
          navigate("/blogs");
        } else {
          toast.error(res.data.message || "Something went wrong");
        }
      }
    } catch (err) {
      setSubmitLoading(false);
      console.log(err);
      toast.error("Something went wrong");
    }
  };

  return (
    <React.Fragment>
      <title>Add Blog</title>
      <div className="WrapperArea _add_partner">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <h4 className="Title back_wrap">
              <Link to="/blogs" className="back_btn">
                <i className="fa fa-arrow-left"></i>
              </Link>
              Add New Blog
            </h4>

            <form onSubmit={handelSubmit} className="my-5">
              <div className="PasswordArea">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Title <span style={{ color: "red" }}>*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Blog Title"
                        name="title"
                        value={inputField.title}
                        onChange={handelInputChange}
                      />
                      <span style={{ color: "red" }} className="error">
                        {errorField.title}
                      </span>
                    </div>

                    <div className="form-group">
                      <label>Meta Title</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Meta Title"
                        name="metaTitle"
                        value={inputField.metaTitle}
                        onChange={handelInputChange}
                      />
                    </div>

                    <div className="form-group">
                      <label>Blog Image <span style={{ color: "red" }}>*</span></label>
                      <div className="upload_image">
                        <label htmlFor="blog-img">
                          <span>Upload Image</span>
                          <i className="fa fa-upload"></i>
                        </label>
                        <input
                          id="blog-img"
                          type="file"
                          className="form-control"
                          name="image"
                          accept="image/*"
                          onChange={handelImageOnchange}
                        />
                      </div>
                      <span style={{ color: "red" }} className="error">
                        {errorField.image}
                      </span>
                      {imagePreview && (
                        <img
                          src={imagePreview}
                          alt="preview"
                          style={{ marginTop: "10px", objectFit: "cover", borderRadius: "6px" }}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Author <span style={{ color: "red" }}>*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Author Name"
                        name="author"
                        value={inputField.author}
                        onChange={handelInputChange}
                      />
                      <span style={{ color: "red" }} className="error">
                        {errorField.author}
                      </span>
                    </div>

                    <div className="form-group">
                      <label>Meta Description</label>
                      <textarea
                        className="form-control"
                        placeholder="Enter Meta Description"
                        name="metaDescription"
                        value={inputField.metaDescription}
                        onChange={handelInputChange}
                        rows="3"
                      />
                    </div>

                    <div className="form-group">
                      <div className="form-check" style={{ marginTop: "10px" }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="isFeatured"
                          checked={inputField.isFeatured}
                          onChange={handelInputChange}
                          id="isFeatured"
                        />
                        <label className="form-check-label" htmlFor="isFeatured">
                          Mark as Featured Blog
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12">
                    <div className="form-group">
                      <label>Description <span style={{ color: "red" }}>*</span></label>
                      <ReactQuill
                        theme="snow"
                        value={description}
                        onChange={setDescription}
                        modules={modules}
                        placeholder="Write blog content here..."
                        style={{ height: "300px", marginBottom: "50px" }}
                      />
                      <span style={{ color: "red" }} className="error">
                        {errorField.description}
                      </span>
                    </div>
                  </div>

                  <div className="button_wrap">
                    <button
                      type="submit"
                      className="button"
                      ref={submitButtonElement}
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      className="button"
                      style={{ marginLeft: "10px", background: "#6c757d" }}
                      onClick={() => navigate("/blogs")}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
